import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field } from '@simonbackx/simple-encoding';
import { ReduceablePrice } from './ReduceablePrice.js';
import { Formatter } from '@stamhoofd/utility';
export var GroupPriceDiscountType;
(function (GroupPriceDiscountType) {
    GroupPriceDiscountType["Fixed"] = "Fixed";
    GroupPriceDiscountType["Percentage"] = "Percentage";
})(GroupPriceDiscountType || (GroupPriceDiscountType = {}));
export class GroupPriceDiscount extends AutoEncoder {
    constructor() {
        super(...arguments);
        /** */
        this.value = ReduceablePrice.create({});
        this.type = GroupPriceDiscountType.Percentage;
    }
    calculateDiscount(price, member) {
        if (this.type === GroupPriceDiscountType.Fixed) {
            return Math.max(0, Math.min(price, this.value.forMember(member)));
        }
        // Discounts should always be rounded to 2 decimals
        return Math.max(0, Math.min(price, 100 * Math.round(price * this.value.forMember(member) / 1000000)));
    }
    toString() {
        if (this.type === GroupPriceDiscountType.Percentage) {
            return Formatter.percentage(this.value.price);
        }
        return Formatter.price(this.value.price);
    }
}
__decorate([
    field({ decoder: ReduceablePrice }),
    field({
        decoder: ReduceablePrice,
        upgrade: function (old) {
            if (this.type === GroupPriceDiscountType.Percentage) {
                // Undo *100
                return ReduceablePrice.create({
                    price: Math.round(old.price / 100),
                    reducedPrice: old.reducedPrice ? Math.round(old.reducedPrice / 100) : old.reducedPrice,
                });
            }
            return old;
        },
        downgrade: function (old) {
            if (this.type === GroupPriceDiscountType.Percentage) {
                // Redo
                return ReduceablePrice.create({
                    price: Math.round(old.price * 100),
                    reducedPrice: old.reducedPrice ? Math.round(old.reducedPrice * 100) : old.reducedPrice,
                });
            }
            return old;
        },
        version: 389,
    })
], GroupPriceDiscount.prototype, "value", void 0);
__decorate([
    field({ decoder: new EnumDecoder(GroupPriceDiscountType) })
], GroupPriceDiscount.prototype, "type", void 0);
//# sourceMappingURL=GroupPriceDiscount.js.map